export default "__VITE_ASSET__Syb16pT$__"